<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :current='page'
      :count='count'
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>日期:</label>
            <timeStampDatePicker type='daterange' class="item" clearable placeholder=" 请选择" v-model.trim='query.createTime'/>
          </div>
          <div class="queryItem">
            <label>日报编号:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.proceedsCode'></lk-input>
          </div>
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <StoreListSelect v-model.trim='query.storeIdList' class="item"></StoreListSelect>
          </div>
          <div class="queryItem">
            <label>核验状态:</label>
            <lk-select class="item" clearable v-model.trim='query.verifyStatus'>
              <lk-option v-for="(item,index) in verifyStatus" :key="index" :value='index+1'>{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>核验日期:</label>
            <timeStampDatePicker type='daterange' class="item" clearable placeholder=" 请选择" v-model.trim='query.verifyTime'/>
          </div>
          <div class="queryItem">
            <label>推送状态:</label>
            <lk-select class="item" clearable v-model.trim='query.pushStatus'>
              <lk-option v-for="(item,index) in pushStatus" :key="index" :value='index+1'>{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>推送日期:</label>
            <timeStampDatePicker type='daterange' class="item" clearable placeholder=" 请选择" v-model.trim='query.pushTime'/>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button type='primary' @click="isGeneratedDailyReport" v-if="handlePermission('generateDailyReport')">
            生成零售日报
          </lk-button>
          <DownloadButton  @on-click="handleExport" text="导出零售统计表" v-if="handlePermission('retailDailyDownload')" ></DownloadButton>
          <DownloadButton  @on-click="handleExport('verify')" text="导出核验进度表" v-if="handlePermission('verifyDailyDownload')" ></DownloadButton>
        </div>
        <lk-table class="cancelTableShadow" border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>
    <!-- 打印报表 开始 -->
    <section id="printArea" ref="print" class="print-area">
      <div v-for="(item, outerIndex) in printInfo.printPageData" :key="item.orderNo">
        <table class="print-table">
          <thead>
          <tr>
            <th colspan="21">
              <h3>{{printInfo.financeProceeds.createTime}}{{printInfo.financeProceeds.storeName}}收入明细</h3>
            </th>
          </tr>
          <tr>
            <th style="width: 1.7%; font-weight: 500;">  </th>
            <th style="width: 11.8%; font-weight: 500;">单据号</th>
            <th style="width: 2.7%; font-weight: 500;">类型</th>
            <th style="width: 5.5%; font-weight: 500;">商品编码</th>
            <th style="width: 5.2%; font-weight: 500;">商品名</th>
            <th style="width: 7.3%; font-weight: 500;">通用名</th>
            <th style="width: 7.3%; font-weight: 500;">规格</th>
            <th style="width: 2.7%; font-weight: 500;">单位</th>
            <th style="width: 5.9%; font-weight: 500;">批次</th>
            <th style="width: 2.7%; font-weight: 500;">数量</th>
            <th style="width: 5.2%; font-weight: 500;">销售单价</th>
            <th style="width: 5.2%; font-weight: 500;">折扣金额</th>
            <th style="width: 5.2%; font-weight: 500;">活动收款</th>
            <th style="width: 3.4%; font-weight: 500;">销税率</th>
            <th style="width: 6%; font-weight: 500;">含税零售额</th>
            <th style="width: 5.2%; font-weight: 500;">零售税额</th>
            <th style="width: 6%; font-weight: 500;">不含税零售额</th>
            <th style="width: 6%; font-weight: 500;">含税成本</th>
            <th style="width: 6%; font-weight: 500;">不含税成本</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data, index) in item" :key="index">
            <!-- 行号 -->
            <td><span>{{index + 1}}</span></td>
            <!-- 单据号 -->
            <td><span>{{data.orderNo}}</span></td>
            <!-- 类型 -->
            <td><span>{{data.goodsTypeName&&(data.goodsTypeName).substring(0,3)}}</span></td>
            <!-- 商品编码 -->
            <td><span>{{data.drugSerialCode}}</span></td>
            <!-- 商品名 -->
            <td><span>{{data.goodsName&&(data.goodsName).substring(0,4)}}</span></td>
            <!-- 通用名 -->
            <td><span>{{data.approvedDrugNames&&(data.approvedDrugNames).substring(0,7)}}</span></td>
            <!-- 规格 -->
            <td><span>{{data.specifications&&(data.specifications).substring(0,7)}}</span></td>
            <!-- 单位 -->
            <td><span>{{data.goodsUnit}}</span></td>
            <!-- 批次 -->
            <td><span>{{data.goodsBatch&&(data.goodsBatch).substring(data.goodsBatch.length - 10,data.goodsBatch.length)}}</span></td>
            <!-- 数量 -->
            <td><span>{{data.goodsCount}}</span></td>
            <!-- 销售单价 -->
            <td style="text-align: right;"><span>{{toFixed2(data.realPrice) || '/'}}</span></td>
            <!-- 折扣金额 -->
            <td style="text-align: right;"><span>{{toFixed2(data.discount) || '/'}}</span></td>
            <!-- 活动收款 -->
            <td style="text-align: right;"><span>{{toFixed2(data.activityProceedsAmount) || '/'}}</span></td>
            <!-- 销税率 -->
            <td style="text-align: right;"><span>{{data.outputTaxRate}}%</span></td>
            <!-- 含税零售额 -->
            <td style="text-align: right;"><span>{{toFixed2(data.totalAmount) || '/'}}</span></td>
            <!-- 零售税额 -->
            <td style="text-align: right;"><span>{{toFixed2(data.totalOutputTax) || '/'}}</span></td>
            <!-- 不含税零售额 -->
            <td style="text-align: right;"><span>{{toFixed2(data.totalAmountAfterTax) || '/'}}</span></td>
            <!-- 含税成本 -->
            <td style="text-align: right;"><span>{{toFixed2(data.totalCostAmount) || '/'}}</span></td>
            <!-- 不含税成本 -->
            <td style="text-align: right;"><span>{{toFixed2(data.totalCostAmountAfterTax) || '/'}}</span></td>
          </tr>
          <tr>
            <td colspan="21">
              <span class="mr32">含税零售额合计：{{toFixed2(printInfo.saleOrderDetailTotal.totalAmount)}}</span>
              <span class="mr32">不含税零售额合计：{{toFixed2(printInfo.saleOrderDetailTotal.totalAmountAfterTax)}}</span>
              <span class="mr32">零售税额合计：{{toFixed2(printInfo.saleOrderDetailTotal.totalOutputTax)}}</span>
              <span class="mr32">不含税成本合计：{{toFixed2(printInfo.saleOrderDetailTotal.totalCostAmountAfterTax)}}</span>
              <span class="mr32">含税成本合计：{{toFixed2(printInfo.saleOrderDetailTotal.totalCostAmount)}}</span>
              <span class="mr32">活动收款合计：{{toFixed2(printInfo.saleOrderDetailTotal.activityProceedsAmount)}}</span>
              <span class="mr32">第{{outerIndex + 1}}页/共{{printInfo.printPageData.length}}页</span>
            </td>
          </tr>
          </tbody>
        </table>
        <p class="page-break"></p>
      </div>
      <div v-for="(item, outerIndex) in printInfo.proceedsPageData" :key="outerIndex">
        <table class="print-table">
          <thead>
          <tr>
            <th colspan="21">
              <h3>{{printInfo.financeProceeds.createTime}}{{printInfo.financeProceeds.storeName}}收款明细</h3>
            </th>
          </tr>
          <tr>
            <th style="width: 1.8%;"> </th>
            <th style="width: 13%; font-weight: 500;">单据号</th>
            <th style="width: 5.5%; font-weight: 500;">业务类型</th>
            <th style="width: 5.8%; font-weight: 500;">订单总额</th>
            <th style="width: 5.8%; font-weight: 500;">收款合计</th>
            <th style="width: 3.7%; font-weight: 500;">找零</th>
            <th style="width: 5.5%; font-weight: 500;">新增预收</th>
            <th style="width: 5.5%; font-weight: 500;">预收退款</th>
            <th style="width: 5.5%; font-weight: 500;">新增应收</th>
            <th style="width: 5.5%; font-weight: 500;">预收核销</th>
            <th style="width: 5.5%; font-weight: 500;">预收退回</th>
            <th style="width: 5.5%; font-weight: 500;">应收核销</th>
            <th style="width: 4%; font-weight: 500;">收银员</th>
            <th style="width: 27%; font-weight: 500;">收款方式明细</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data, index) in item" :key="index">
            <!-- 行号 -->
            <td><span>{{index + 1}}</span></td>
            <!-- 单据号 -->
            <td><span>{{data.referCode}}</span></td>
            <!-- 业务类型 -->
            <td><span>{{data.referTypeName&&(data.referTypeName).substring(0,5)}}</span></td>
            <!-- 订单总额 -->
            <td style="text-align: right;"><span>{{toFixed2(data.amount) || '/'}}</span></td>
            <!-- 收款合计 -->
            <td style="text-align: right;"><span>{{toFixed2(data.proceedsAmount) || '/'}}</span></td>
            <!-- 找零 -->
            <td style="text-align: right;"><span>{{toFixed2(data.proceedsChange) || '/'}}</span></td>
            <!-- 新增预收 -->
            <td style="text-align: right;"><span>{{toFixed2(data.addDeposit) || '/'}}</span></td>
            <!-- 预收退款 -->
            <td style="text-align: right;"><span>{{toFixed2(data.depositRefund) || '/'}}</span></td>
            <!-- 新增应收 -->
            <td style="text-align: right;"><span>{{toFixed2(data.addReceivables) || '/'}}</span></td>
            <!-- 预收核销 -->
            <td style="text-align: right;"><span>{{toFixed2(data.depositVerification) || '/'}}</span></td>
            <!-- 预收退回 -->
            <td style="text-align: right;"><span>{{toFixed2(data.depositVerificationRefund) || '/'}}</span></td>
            <!-- 应收核销 -->
            <td style="text-align: right;"><span>{{toFixed2(data.receivablesVerification) || '/'}}</span></td>
            <!-- 收银员 -->
            <td><span>{{data.proceedsUserName&&(data.proceedsUserName).substring(0,3)}}</span></td>
            <!-- 收款方式明细 -->
            <td><span>{{data.proceedsString&&(data.proceedsString).substring(0,30)}}</span></td>
          </tr>
          <tr>
            <td colspan="3" class="text-left"><span>合计：</span></td>
            <!-- 订单总额 -->
            <td style="text-align: right;"><span>{{toFixed2(printInfo.proceedsInfoTotal.amount)}}</span></td>
            <!-- 收款合计 -->
            <td style="text-align: right;"><span>{{toFixed2(printInfo.proceedsInfoTotal.proceedsAmount)}}</span></td>
            <!-- 找零 -->
            <td style="text-align: right;"><span>{{toFixed2(printInfo.proceedsInfoTotal.proceedsChange)}}</span></td>
            <!-- 新增预收 -->
            <td style="text-align: right;"><span>{{toFixed2(printInfo.proceedsInfoTotal.addDeposit)}}</span></td>
            <!-- 预收退款 -->
            <td style="text-align: right;"><span>{{toFixed2(printInfo.proceedsInfoTotal.depositRefund)}}</span></td>
            <!-- 新增应收 -->
            <td style="text-align: right;"><span>{{toFixed2(printInfo.proceedsInfoTotal.addReceivables)}}</span></td>
            <!-- 预收核销 -->
            <td style="text-align: right;"><span>{{toFixed2(printInfo.proceedsInfoTotal.depositVerification)}}</span></td>
            <!-- 预收退回 -->
            <td style="text-align: right;"><span>{{toFixed2(printInfo.proceedsInfoTotal.depositVerificationRefund)}}</span></td>
            <!-- 应收核销 -->
            <td style="text-align: right;"><span>{{toFixed2(printInfo.proceedsInfoTotal.receivablesVerification)}}</span></td>
            <td colspan="2" class="text-center"><span>第{{outerIndex + 1}}页/共{{printInfo.proceedsPageData.length}}页</span></td>
          </tr>
          </tbody>
        </table>
        <p class="page-break"></p>
      </div>
      <!-- 收款汇总 开始-->
      <table class="print-table">
        <thead>
        <tr>
          <th :colspan="(11)">
            <h3>{{printInfo.financeProceeds.createTime}}{{printInfo.financeProceeds.storeName}}收款汇总</h3>
          </th>
        </tr>
        <tr>
          <th style="width: 9%;">门店名称：</th>
          <th style="width: 16%;">{{printInfo.financeProceeds.storeName}}</th>
          <th style="width: 9%;">会计日：</th>
          <th style="width: 16%;">{{printInfo.financeProceeds.createTime}}</th>
          <th style="width: 9%;">收款金额合计：</th>
          <th style="width: 16%;">{{toFixed2(printInfo.printSummaryVo.proceedsAmountTotal)}}</th>
          <th style="width: 9%;">找零合计：</th>
          <th style="width: 16%;">{{toFixed2(printInfo.printSummaryVo.proceedsChangeTotal)}}</th>
        </tr>
        <tr v-if='printInfo.methodData.length > 0'>
          <th :colspan="(11)">
            <h3>收款方式明细</h3>
          </th>
        </tr>
        <tr v-for="(data, index) in printInfo.methodData" :key="index">
          <div v-for="(item, index) in data" :key="index">
            <th>{{item.proceedsTypeName}}：</th>
            <th>{{toFixed2(item.amount)}}</th>
          </div>
          <div v-if="data.length < 4 && data.length > 0">
            <div v-for="(item, index) in 4-data.length" :key="index">
              <th></th>
              <th></th>
            </div>
          </div>
        </tr>
        <tr>
          <th :colspan="(11)">
            <h3>应收预收统计</h3>
          </th>
        </tr>
        <tr>
          <th>新增预收：</th>
          <th>{{toFixed2(printInfo.printSummaryVo.addDepositTotal)}}</th>
          <th>新增应收：</th>
          <th>{{toFixed2(printInfo.printSummaryVo.addReceivablesTotal)}}</th>
          <th>预收核销：</th>
          <th>{{toFixed2(printInfo.printSummaryVo.depositVerificationTotal)}}</th>
          <th>应收核销：</th>
          <th>{{toFixed2(printInfo.printSummaryVo.receivablesVerificationTotal)}}</th>
        </tr>
        <tr>
          <th>预收退款：</th>
          <th>{{toFixed2(printInfo.printSummaryVo.depositRefundTotal)}}</th>
          <th></th>
          <th></th>
          <th>预收核销退回：</th>
          <th>{{toFixed2(printInfo.printSummaryVo.depositVerificationRefundTotal)}}</th>
          <th></th>
          <th></th>
        </tr>
        <tr>
          <th :colspan="(11)">
            <span class="mr32 test-left">订单总额：{{toFixed2(printInfo.printSummaryVo.totalAmount)}}</span>
              <span class="mr32">收款：{{toFixed2(printInfo.printSummaryVo.totalProceedsAmount)}}</span>
              <span class="mr32">预收：{{toFixed2(printInfo.printSummaryVo.totalDeposit)}}</span>
              <span class="mr32">应收：{{toFixed2(printInfo.printSummaryVo.totalReceivables)}}</span>
              <span class="mr32" style="color: gainsboro">订单总额 = 收款 - 预收 + 应收</span>
              <span class="mr32">第1页/共1页</span>
          </th>
        </tr>
      </thead>
        <tbody>
        </tbody>
      </table>
      <p class="page-break"></p>
      <!-- 销售汇总 结束-->
    </section>
    <!-- 打印报表 结束 -->
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import finance from '../../services/finance';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import DownloadButton from '../../components/download/DownloadButton.vue';

export default {
  name: 'payment',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
  },
  // computed: {
    
  // },
  data() {
    return {
      loading: false,
      query: {
        createTime: [],
        proceedsCode: '',
        verifyStatus: '',
        pushStatus: '',
        verifyTime: [],
        pushTime: [],
      },
      tableData: [],
      printInfo: {
        financeProceeds: {},
        saleProceedsVo: {},
        printPageData: {},
        proceedsPageData: {},
        methodData: {},
        printSummaryVo: {},
        proceedsInfoTotal: {},
        saleOrderDetailTotal: {},
      },
      verifyStatus: ['待核验', '已核验', '待订正', '已过期', '预生成'],
      pushStatus: ['已推送', '未推送'],
      retailDailyObj: {},
      columns: [
        { title: '日期', key: 'bizDate', minWidth: 116 },
        { title: '日报编号', key: 'code', minWidth: 116 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '核验状态', key: 'verifyStatus', minWidth: 116 },
        {
          title: '核验时间',
          key: 'verifyTime',
          minWidth: 116,
          render: (h, params) => h('span', params.row.verifyTime ? utils.exchangeTime(params.row.verifyTime) : '-'),
        },
        { title: '推送状态', key: 'pushStatusName', minWidth: 116 },
        {
          title: '推送时间',
          key: 'pushTime',
          minWidth: 116,
          render: (h, params) => h('span', params.row.pushTime ? utils.exchangeTime(params.row.pushTime) : '-'),
        },
        { title: '总销售收入（含税）', key: 'allProfitAmount', minWidth: 116 },
        { title: '总收款金额', key: 'allProfitAmountWithoutTax', minWidth: 116 },
        { title: '总单据数', key: 'documentsNum', minWidth: 116 },
        { title: '订正记录数', key: 'verifiedNum', minWidth: 116 },
        { title: '核验人', key: 'modifiedUserName', minWidth: 116 },
        {
          title: '操作',
          minWidth: 116,
          fixed: 'right',
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'retailDailyCheck', params: { id: params.row.id } });
                },
              },
            }, '查看'),
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.getPrintData(params.row.id);
                },
              },
            }, '打印'),
            this.handlePermission('retailDailyRevision') && params.row.verifyStatus === '待核验' ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: params.row.doVerify === 1,
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'retailDailyRevision', params: { id: params.row.id } });
                },
              },
            }, '核验') : null,
            this.handlePermission('retailDailyVerify') && params.row.verifyStatus === '待订正' ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: params.row.doVerify === 1,
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'retailDailyVerify', params: { id: params.row.id } });
                },
              },
            }, '订正') : null,
          ]),
        },
      ],
      printPage: {
        size: 36,
        count: 0,
      },
      proceedsPrintPage: {
        size: 36,
        count: 0,
      },
      timeList: [],
    };
  },
  methods: {
    toFixed2(num) {
      if (num * 1 != 0) {
        return utils.toFixed2(num, 2);
      }
      return '0.00';
    },
    handleExport(type) {
      const params = utils.deepClone(this.params);
      if (params.createTime) {
        params.createTimeStart = params[0];
        params.createTimeEnd = params[1];
        delete params.createTime;
      }
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      delete params.page;
      delete params.size;
      let request = null;
      if (type === 'verify') {
        request = finance.getFinanceVerifyListDownload(params);
      } else {
        request = finance.getFinanceProceedsListDownload(params);
      }
      request.then((res) => {
        if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        date: [],
        proceedsCode: '',
        checkState: '',
        pushStatus: '',
        verifyTime: [],
        pushTime: [],
        storeIdList: [],
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      const timeNameList = ['createTime', 'verifyTime', 'pushTime'];
      timeNameList.forEach((item) => {
        if (this.params[item] && this.params[item].length === 2) {
          this.params[`${item}Start`] = this.params[item][0];
          this.params[`${item}End`] = this.params[item][1];
          delete this.params[item];
        }
      });
      finance.getFinanceProceedsList(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.tableData = [];
          this.count = count;
          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.bizDate = utils.exchangeTime(result.bizDate);
            result.verifyStatus = this.verifyStatus[result.verifyStatus - 1];
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPrintData(financeProceedsId) {
      finance.getProceedsPrintData({ financeProceedsId }).then((res) => {
        if (res.data.status === 200) {
          const temp = res.data.data;
          temp.printPageData = [];
          this.printPage.count = temp.saleOrderDetailList.length;
          if (this.printPage.count) { // 收入明细
            const pages = Math.ceil(this.printPage.count / this.printPage.size); // 总页数
            for (let i = 1; i <= pages; i++) {
              const currentNum = (i - 1) * this.printPage.size;
              const currentData = temp.saleOrderDetailList.slice(currentNum, currentNum + this.printPage.size);
              temp.printPageData.push(currentData);
            }
          }
          temp.financeProceeds.createTime = utils.formatDate(temp.financeProceeds.createTime);
          // 收款明细
          temp.proceedsPageData = [];
          this.proceedsPrintPage.count = temp.proceedsInfoList.length;
          if (this.proceedsPrintPage.count) { // 收入明细
            const pages = Math.ceil(this.proceedsPrintPage.count / this.proceedsPrintPage.size); // 总页数
            for (let i = 1; i <= pages; i++) {
              const currentNum = (i - 1) * this.proceedsPrintPage.size;
              const currentData = temp.proceedsInfoList.slice(currentNum, currentNum + this.proceedsPrintPage.size);
              temp.proceedsPageData.push(currentData);
            }
          }
          // 收款汇总
          temp.methodData = [];
          if (temp.printSummaryVo.proceedsList.length) { // 收入明细
            const pages = Math.ceil(temp.printSummaryVo.proceedsList.length / 4); // 总页数
            for (let i = 1; i <= pages; i++) {
              const currentNum = (i - 1) * 4;
              const currentData = temp.printSummaryVo.proceedsList.slice(currentNum, currentNum + 4);
              temp.methodData.push(currentData);
            }
          }
          this.printInfo = temp;
          this.$nextTick(() => {
            this.$print(this.$refs.print);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    submitRevisionData(params) {
      finance.submitRevisionList(params).then((res) => {
        if (res.data.stauts === 200) {
          this.$Message.success('提交成功');
          this.$router.push({ name: 'otherProfitLog' });
        } else {
          this.$Message.error(res.data.error);
        }
      });
    },
    submitVerifyData(params) {
      finance.submitVerifyList(params).then((res) => {
        if (res.data.stauts === 200) {
          this.$Message.success('提交成功');
          this.$router.push({ name: 'otherProfitLog' });
        } else {
          this.$Message.error(res.data.error);
        }
      });
    },
    generateDailyReport() {
      finance.generateDailyReport().then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('零售日报已生成');
          this.getData();
        } else {
          this.$Message.warning(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    updateDailyReport(proceedsId) {
      finance.updateDailyReport({ proceedsId }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('零售日报已更新');
          this.getData();
        } else {
          this.$Message.warning(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    isGeneratedDailyReport() {
      finance.isGeneratedDailyReport().then((res) => {
        if (res.data.status === 200) {
          this.retailDailyObj = res.data.data;
          this.$Modal.confirm({
            title: this.retailDailyObj.prompt,
            content: this.retailDailyObj.timeFrame,
            onOk: () => {
              this.retailDailyObj.isHaveReport === 1 ? this.updateDailyReport(this.retailDailyObj.id) : this.generateDailyReport();
            },
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.handleSearch(true);
    this.getData();
  },
};
</script>
<style lang="less" scoped>
  .btns{
    margin-bottom: 12px;
    >*{
      margin-right: 16px
    }
  }
  .queryContainer{//样式写进公共类中
    display: flex;
    padding-bottom: 16px;
    flex-wrap: wrap;

    .queryItem{
      display: flex;
      align-items: center;
      margin-right: 32px;
      flex-wrap: wrap;
      margin-bottom: 15px;
      .item{
        display: inline-block;
        width: 256px
      }
    }
  }
  @media print {
    .print-area {
      display: block;
    }
    .page-break {
      page-break-after: always;
    }
  }
  @media screen {
    .print-area {
      display: none;
    }
  }
  .mr32{
    margin-right: 32px
  }
  .print-table {
    width: 100%;
    text-align: left;
    border-collapse: collapse;
    border-spacing: 0;
    td,
    th {
      padding: 0 2px;
      border: 1px solid;
      overflow: hidden;
      white-space: nowrap;
    }
    thead {
      th,
      td {
        font-size: 12px;
        font-weight: normal;
        text-align: center;
      }
    }
    tbody {
      td {
        font-size: 12px;
        text-align: left;
        padding: 0 2px;
        span {
          font-size: 12px;
          word-break: break-all;
          &.small {
            transform: scale(0.6) translateX(0);
          }
        }
      }
    }
    .range {
      display: inline-block;
      min-width: 50px;
      max-width: 160px;
      white-space: nowrap;    /* 先设置为强制不换行 */
      text-overflow: ellipsis;    /* 超出设为为省略号 */
      overflow: hidden;           /* 超出隐藏 */
    }
    .text-right {
      padding-right: 8px;
      text-align: right;
    }
    .text-center {
      padding-right: 8px;
      text-align: center;
    }
  }
</style>
